import axios from 'axios'
import store from '../store'

const axiosObj = axios.create({
  baseURL: process.env.PAYMENT_URL, // 'http://localhost:8000/api/v2/',
  headers: {
    // 'mactoken': Vue.ls.get('tss_mac_token'),
    'Content-Type': 'application/json'
  }
})
axiosObj.interceptors.request.use((config) => {
  store.dispatch('LOADING', true)
  return config
})
axiosObj.interceptors.response.use((response) => {
  store.dispatch('LOADING', false)
  return response
}, function (error) {
  store.dispatch('LOADING', false)
  return Promise.reject(error.response)
})
export default axiosObj



// WEBPACK FOOTER //
// ./src/api/payment.js